// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2819":"6ffe784f","4068":"46debe39"}[chunkId] + ".chunk.css";
};